const PICKUP_OPTIMYZER_FILTERS = {
  assigned: "Assigned",
  unassigned: "Unassigned",
  excludeSwapPickups: "Exclude Swap Pickups",
};
const PICKUP_OPTIMYZER_STEPS = [
  "Correct Pickup Information",
  "Select Drivers",
  "Review Optymized Solution",
  "Results",
];

const PICKUP_OPTIMYZER_STEP = {
  CORRECT_PICKUP_INFO: 0,
  SELECT_DRIVERS: 1,
  REVIEW_OPTIMIZED_SOLUTION: 2,
  RESULTS: 3,
};

const PICKUP_OPTIMYZER_FILTER_NAME = {
  isAssigned: "isAssigned",
  isUnassigned: "isUnassigned",
  excludeSwapPickups: "excludeSwapPickups",
};

export {
  PICKUP_OPTIMYZER_FILTERS,
  PICKUP_OPTIMYZER_STEPS,
  PICKUP_OPTIMYZER_STEP,
  PICKUP_OPTIMYZER_FILTER_NAME,
};
